import { store } from '@src/state/store';
import { onJoinedGame } from '@src/state/slices/slice_game';
import { setStage } from '@src/state/slices/slice_app';
import { Stage } from '@src/state/slices/types';
import { setPlayerMeta } from '@src/state/slices/slice_game';

export default () => (data: any) => {
  store.dispatch(onJoinedGame(data));
  store.dispatch(
    setStage({ stage: Stage.SHOW_GAME, stageMeta: { gameId: data.gameId } }),
  );
  store.dispatch(
    setPlayerMeta({
      playerId: data.playerId,
      playerIndex: data.playerIndex,
      name: '',
    }),
  );
};
